import { Mapper } from '../../../common/ddd/mapper.base';
import { formatDeviationPrefix, formatDuration } from '../../../common';
import { SelfTopAppCategoryAppsAggregateRoot } from '../../../core/domain/aggregates/app-category-metrics/self-top-app-category-apps.aggregate-root';
import { GetSelfTopAppCategoryAppsResponse } from '../../../interface/dtos/app-category-metrics/get-self-top-app-category-apps.response.dto';

export type ISelfTopAppCategoryAppsAggregateRootMapper = Mapper<
  SelfTopAppCategoryAppsAggregateRoot,
  GetSelfTopAppCategoryAppsResponse
>;

export class SelfTopAppCategoryAppsAggregateRootMapper
  implements Omit<ISelfTopAppCategoryAppsAggregateRootMapper, 'toDomain'>
{
  toResponse(
    entity: SelfTopAppCategoryAppsAggregateRoot
  ): GetSelfTopAppCategoryAppsResponse {
    return SelfTopAppCategoryAppsAggregateRootMapper.toResponse(entity);
  }

  static toResponse(
    entity: SelfTopAppCategoryAppsAggregateRoot
  ): GetSelfTopAppCategoryAppsResponse {
    return {
      appId: entity.appId,
      totalDuration: Number(entity.totalDuration),
      formattedTotalDuration: formatDuration(entity.totalDuration),
      totalDurationDeviation: `${formatDeviationPrefix(
        entity.totalDurationDeviation
      )}${formatDuration(entity.totalDurationDeviation)}`,
    };
  }
}
